import React, { Component } from 'react';
import { array, func, object } from 'prop-types';
import find from 'lodash/find';
import { withTheme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';

import { isPremium } from '../../util/common';
import { setCurrentProfile } from '../../util/options';

// Options profile picker beside the Options button (Premium only)
class OptionsProfileButton extends Component {
  static propTypes = {
    user: object,
    optionsProfiles: array,
    onProfileSelect: func,
    theme: object
  };

  state = { anchorEl: null };

  selectProfile = profile => {
    setCurrentProfile(this.props.user.sessionToken, profile, this.props.onProfileSelect);
    this.setState({ anchorEl: null });
  };

  render() {
    const { user, optionsProfiles, theme } = this.props;
    const premium = isPremium(user);
    const currentProfile = find(optionsProfiles, ['current_profile', 1]);
    const selectedProfile = currentProfile ? currentProfile.options_name : 'Default Profile';

    return (
      <div title={premium ? null : 'Upgrade to DiffNow Premium to use options profiles'}>
        <Button
          variant="outlined"
          disabled={!premium}
          aria-owns={this.state.anchorEl ? 'profiles-menu' : null}
          aria-haspopup="true"
          onClick={e => this.setState({ anchorEl: e.currentTarget })}
          style={{ textTransform: 'none', minHeight: 36, padding: '0 6px 0 12px' }}
        >
          {selectedProfile}
          <Icon>arrow_drop_down</Icon>
        </Button>
        <Menu
          id="profiles-menu"
          open={!!this.state.anchorEl}
          anchorEl={this.state.anchorEl}
          onClose={() => this.setState({ anchorEl: null })}
          TransitionComponent={Fade}
        >
          {optionsProfiles.map(profile => (
            <MenuItem
              key={profile.options_name}
              style={{
                backgroundColor:
                  selectedProfile === profile.options_name
                    ? theme.palette.selectedProfileColor
                    : theme.palette.unselectedProfileColor
              }}
              onClick={() => this.selectProfile(profile.options_name)}
            >
              {profile.options_name}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
  }
}

export default withTheme()(OptionsProfileButton);
